export class ParticipantSessionReviewFile implements IParticipantSessionReviewFile {
    fileId?: string;
    assetType?: string | undefined;

    constructor(data?: IParticipantSessionReviewFile) {
        if (data) {
            for (const property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data['fileId'];
            this.assetType = _data['assetType'];
        }
    }

    static fromJS(data: any): ParticipantSessionReviewFile {
        data = typeof data === 'object' ? data : {};
        const result = new ParticipantSessionReviewFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['fileId'] = this.fileId;
        data['assetType'] = this.assetType;
        return data;
    }
}

export interface IParticipantSessionReviewFile {
    fileId?: string;
    assetType?: string | undefined;
}